// The request vocabulary, shared by the triage queue, the triage modal and
// the reporter's own page.
//
// These mirror Request on the backend (back_office/models.py). Where the
// backend derives something -- next_step_with, estimate_display -- the
// server's value is what gets displayed; the maps here are only for colour
// and for the pickers. Nothing in this file decides anything the server does
// not already enforce.
export const REQUEST_STATUSES = [
    {value: 'submitted', label: 'Submitted', chip: 'bg-gray-100 text-gray-700'},
    {value: 'under_review', label: 'Under Review', chip: 'bg-blue-100 text-blue-800'},
    {value: 'investigating', label: 'Investigating', chip: 'bg-cyan-100 text-cyan-800'},
    {value: 'needs_info', label: 'Need More Information', chip: 'bg-orange-100 text-orange-800'},
    {value: 'planned', label: 'Planned', chip: 'bg-indigo-100 text-indigo-800'},
    {value: 'in_progress', label: 'In Progress', chip: 'bg-yellow-100 text-yellow-800'},
    {value: 'shipped', label: 'Shipped', chip: 'bg-green-100 text-green-800'},
    {value: 'declined', label: 'Declined', chip: 'bg-gray-200 text-gray-600'},
]

// Blank is a real state -- intake takes words and nothing else, so a request
// is untyped until triage types it.
export const REQUEST_KINDS = [
    {value: 'bug', label: 'Bug', chip: 'bg-red-100 text-red-800'},
    {value: 'feature', label: 'Feature', chip: 'bg-sky-100 text-sky-800'},
    {value: 'improvement', label: 'Improvement', chip: 'bg-violet-100 text-violet-800'},
]

export const REQUEST_ESTIMATES = [
    {value: 'specific_date', label: 'A specific date'},
    {value: 'within_day', label: 'Within the day'},
    {value: 'one_to_two_days', label: '1 to 2 days'},
    {value: 'two_to_five_days', label: '2 to 5 days'},
    {value: 'over_five_days', label: 'More than 5 days'},
]

// The one band that needs a date alongside it; the server refuses the pairing
// if it is missing and clears a stranded date when the band changes.
export const ESTIMATE_NEEDS_DATE = 'specific_date'

// Statuses the team cannot act further on. Mirrors Request.CLOSED_STATUSES.
export const REQUEST_CLOSED_STATUSES = ['shipped', 'declined']

// Everything still live: filed but not finished. Derived rather than listed,
// so a status added above lands here without anybody remembering to add it --
// a new state is in play until somebody decides it closes a request.
export const REQUEST_IN_PLAY_STATUSES = REQUEST_STATUSES
    .map(s => s.value)
    .filter(value => !REQUEST_CLOSED_STATUSES.includes(value))

// Whose move it is, as the server derives it from status.
export const NEXT_STEP_CHIPS = {
    reporter: 'bg-orange-100 text-orange-800',
    team: 'bg-blue-100 text-blue-800',
}

export function requestStatusLabel(value) {
    const found = REQUEST_STATUSES.find(s => s.value === value)
    return found ? found.label : value || ''
}

export function requestStatusChip(value) {
    const found = REQUEST_STATUSES.find(s => s.value === value)
    return found ? found.chip : 'bg-gray-100 text-gray-700'
}

export function requestKindChip(value) {
    const found = REQUEST_KINDS.find(k => k.value === value)
    return found ? found.chip : 'bg-gray-100 text-gray-500'
}

export function nextStepChip(value) {
    return NEXT_STEP_CHIPS[value] || 'bg-gray-100 text-gray-500'
}
